(() => {
  const SMARTFIT_PRODUCT_SEL = '[data-smartfit-product]';
  const VARIANTS_SEL = '[data-smartfit-variants]';
  const DROPDOWN_HOST_SEL = '.option-selector[data-selector-type="dropdown"] custom-select';
  const OPT_SEL = '.custom-select__option';
  const LISTED_HOST_SEL = '.option-selector[data-selector-type="listed"]';
  const RADIO_SEL = 'input[type="radio"]';

  // ---------- Helpers ----------
  const getSmartfitRoot = (widget) =>
    widget?.closest(SMARTFIT_PRODUCT_SEL) || document.querySelector(SMARTFIT_PRODUCT_SEL);
  const getProductInfoRoot = (widget) =>
    getSmartfitRoot(widget)?.closest('.product-info');
  const getVariants = (widget) => {
    const variants = getSmartfitRoot(widget)?.querySelector(VARIANTS_SEL);
    return variants ? JSON.parse(variants.textContent) : [];
  };
  const normalizePayload = (arg) => (arg && arg.detail) ? arg.detail : arg;
  const findVariant = ({ code }, vars) =>
    vars.find(v => String(v.id) === String(code) || v.barcode === code || v.sku === code);

  function pickValue(value, root) {
    const host = root?.querySelector(DROPDOWN_HOST_SEL);
    if (!host) return console.warn('[SF] custom-select Host nicht gefunden');

    const opt = host.querySelector(`${OPT_SEL}[data-value="${CSS.escape(value)}"]`);
    if (!opt) return console.warn('[SF] Option nicht gefunden:', value);

    // 1st choice: interne API
    if (typeof host.selectOption === 'function') {
      host.selectOption(opt);
    } else {
      // Fallback: Button öffnen + Maus-Events simulieren
      const btn = host.querySelector('.custom-select__btn');
      if (btn && btn.getAttribute('aria-expanded') === 'false') btn.click();

      opt.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
      opt.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      opt.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
    }

    // Extra safety: Change feuern
    host.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function pickValueListed(value, root) {
    // Try to find any listed host that contains a radio with the desired value
    const hosts = root?.querySelectorAll(LISTED_HOST_SEL);
    if (!hosts || hosts.length === 0) {
      console.warn('[SF] Listed Host nicht gefunden');
      return false;
    }

    for (const host of hosts) {
      const radio = host.querySelector(`${RADIO_SEL}[value="${CSS.escape(value)}"]`);
      if (!radio) continue;

      // Click the radio; this sollte das change-Event im Theme auslösen
      radio.click();

      // Safety: falls das Theme auf manuelles change hofft, noch einmal feuern
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    console.warn('[SF] Radio-Option nicht gefunden:', value);
    return false;
  }

  // ---------- Main ----------
  function selectSuggestedSize(arg) {
    const payload = normalizePayload(arg);
    const widget = arg?.currentTarget || arg?.target?.closest?.('sf-product-sizing');
    const productRoot = getProductInfoRoot(widget);
    const variants = getVariants(widget);
    const variant = findVariant(payload, variants);

    if (!variant) return console.warn('[SF] Kein Variantentreffer', payload);

    const wanted = variant.option1 || variant.title;
    if (pickValue(wanted, productRoot)) {
      console.log('[SF] Größe gesetzt (Dropdown):', wanted, variant);
    } else if (pickValueListed(wanted, productRoot)) {
      console.log('[SF] Größe gesetzt (Listed):', wanted, variant);
    } else {
      console.warn('[SF] Konnte Größe nicht setzen:', wanted, variant);
    }
  }

  function syncProductBlockVisibility(widget) {
    const productBlock = widget.closest('.product-info__block');
    const slot = widget.shadowRoot?.querySelector('slot');

    if (!productBlock || !slot) return;

    const hasVisibleContent = slot.assignedElements({ flatten: true }).some((element) => {
      const styles = getComputedStyle(element);
      return !element.hidden && styles.display !== 'none' && styles.visibility !== 'hidden';
    });

    productBlock.hidden = !hasVisibleContent;
  }

  function observeProductBlockVisibility(widget) {
    const productBlock = widget.closest('.product-info__block');
    if (!productBlock) return;

    const bindSlot = () => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindSlot, { once: true });
        return;
      }

      const slot = widget.shadowRoot?.querySelector('slot');
      if (!slot) return;

      let emptyStateTimer;
      const sync = () => {
        const hasAssignedContent = slot.assignedElements({ flatten: true }).length > 0;

        if (hasAssignedContent) {
          clearTimeout(emptyStateTimer);
          syncProductBlockVisibility(widget);
          return;
        }

        clearTimeout(emptyStateTimer);
        emptyStateTimer = setTimeout(() => {
          syncProductBlockVisibility(widget);
        }, 2500);
      };

      slot.addEventListener('slotchange', sync);
      sync();
    };

    if (widget.matches(':defined')) {
      bindSlot();
    } else {
      customElements.whenDefined(widget.localName).then(bindSlot);
    }
  }

  // Exponieren + Listener anhängen
  window.selectSuggestedSize = selectSuggestedSize;
  document.querySelectorAll(`${SMARTFIT_PRODUCT_SEL} sf-product-sizing`).forEach((widget) => {
    widget.addEventListener('select', selectSuggestedSize);
    observeProductBlockVisibility(widget);
  });
})();
